<div class="container">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="fs-2 fw-light mt-4">View Payment</h1>
      <button class="btn btn-secondary" (click)="goBack()">
        <fa-icon [icon]="faArrowLeft"></fa-icon> Back
      </button>>
      </div>
    <form [formGroup]="viewPaymentForm" >
      <!-- <div class="form-group my-4">
      <label class="form-label" for="firstname">Period</label>
      <input class="form-control col-3"  type="text" placeholder="Period" formControlName="period" [ngClass]="{ 'is-invalid': submitPaymentData && poa.period.errors, 'is-valid': poa.period.valid && poa.period.touched }"/>
    </div> -->
    <div class="form-group my-4">
      <label class="form-label" for="firstname">Amount</label>
      <input class="form-control col-3"  type="text" placeholder="Amount e.g 1200" formControlName="amount" [ngClass]="{ 'is-invalid': submitPaymentData && poa.amount.errors, 'is-valid': poa.amount.valid && poa.amount.touched }"/>
    </div>
    <div class="form-group my-4">
      <label>Maintenance Period(s) paid with this Payment</label>
      <!-- <p>Show last 12 months as checkbox items</p> -->
      @for (period of payment.payment_obligations; track period) {
        <div class="alert alert-info mx-2">
          <span class="d-block">
            {{ period.obligationperiod | date: 'MMM-y':'UTC' | orderBy: 'obligationperiod' : sortOrder}}
          </span>
          <span class="d-block">
            {{ period.amount | currency }}
          </span>
        </div>
      }
    </div>
    <div class="form-group my-4">
      <label class="form-label" for="description">Description</label>
      <input class="form-control col-3"  type="text" placeholder="Payment for Period" formControlName="description"  />
    </div>
    <div class="form-group my-4">
      <label class="form-label" for="period_date">Payment Date</label>
      <input class="form-control col-3"  type="text" placeholder="January-1-2020" formControlName="period_date"  />
    </div>
    <div class="form-group my-4">
      <label class="form-label" for="effective_date">Effective Date</label>
      <input class="form-control col-3"  type="text" placeholder="January-1-2020" formControlName="effective_date"  />
    </div>
    <div class="form-group my-4">
      <label class="form-label" for="firstname">Paid By</label>
      <input class="form-control col-3"  type="text" placeholder="Paid by e.g John Brown" formControlName="paid_by" [ngClass]="{ 'is-invalid': submitPaymentData && poa.paid_by.errors, 'is-valid': poa.paid_by.valid && poa.paid_by.touched }"/>
    </div>
    <div class="form-group">
      <label class="form-label">Payment Method</label>
      <select class="form-select form-control" formControlName="payment_method">
        <option value="1">Cash </option>
        <option value="2">Credit Card </option>
        <option value="3">Bank Transfer </option>
      </select>
    </div>
    <div class="form-group my-4">
      <label class="form-label" for="firstname">Lot/Unit Number</label>
      <input class="form-control col-3"  type="text" placeholder="Lot/Unit number" formControlName="unitNumber" [ngClass]="{ 'is-invalid': submitPaymentData && poa.premiseId.errors, 'is-valid': poa.premiseId.valid && poa.premiseId.touched }" readonly/>
      <input class="form-control col-3"  type="hidden" formControlName="premiseId" readonly/>
    </div>
    <div class="form-group my-4">
      <label class="form-label" for="property">Property</label>
      <input class="form-control col-3"  type="text" placeholder="Property" formControlName="propertyName" [ngClass]="{ 'is-invalid': submitPaymentData && poa.premiseId.errors, 'is-valid': poa.premiseId.valid && poa.premiseId.touched }" readonly/>
    </div>
  </form>
</div>
